import { Clear } from '@mui/icons-material';
import { IconButton, TextField, TextFieldProps } from '@mui/material';
import { MouseEventHandler } from 'react';

function getDisplayValue(value: unknown, isMultiSelect?: boolean) {
  if (isMultiSelect) {
    return Array.isArray(value) && value.length > 0 ? 'flex' : 'none';
  }
  return value ? 'flex' : 'none';
}

function getPaddingValue(value: unknown, renderValue: unknown) {
  const corrected = {
    '& .MuiSelect-select': {
      paddingTop: '12px',
      paddingBottom: '12px',
    },
  };

  if (Array.isArray(value) && value.length > 0) {
  }

  if (value && renderValue) {
    return corrected;
  }
  return {};
}

export type ClearableSelectProps = {
  onClear?: MouseEventHandler<HTMLButtonElement>;
  isClearable?: boolean;
  multiple?: boolean;
  renderValue?: (value: unknown) => React.ReactNode;
} & TextFieldProps;

export default function ClearableSelect(props: ClearableSelectProps) {
  const {
    onClear,
    isClearable,
    multiple,
    renderValue,
    value,
    inputProps,
    sx,
    ...rest
  } = props;

  return (
    <TextField
      {...rest}
      inputProps={inputProps}
      select
      sx={{ ...sx, ...getPaddingValue(value, props.renderValue) }}
      defaultValue={multiple ? [] : ''}
      value={value ?? (multiple ? [] : '')}
      InputProps={{
        endAdornment: props.isClearable && (
          <IconButton
            disabled={props.disabled || inputProps?.readOnly}
            size="small"
            sx={{
              display: getDisplayValue(props.value, props.multiple),
              mr: 2,
            }}
            onClick={props.onClear}
          >
            <Clear fontSize="small" />
          </IconButton>
        ),
      }}
      SelectProps={{
        multiple: props.multiple,
        renderValue: props.renderValue,
      }}
    >
      {props.children}
    </TextField>
  );
}
